import { useLogoutMutation } from "@qw/graphql";
import { useAtom } from "jotai";
import { authDataAtom } from "../atoms";
import { clearDesktopAuthSession, hasDesktopAuthSessionBridge } from "../desktop-auth";

export function useLogout() {
  const [authData, setAuthData] = useAtom(authDataAtom);

  const [logout] = useLogoutMutation();

  return function () {
    const finalizeLogout = async () => {
      setAuthData(null);
      await clearDesktopAuthSession();
      if (!hasDesktopAuthSessionBridge()) {
        globalThis.location.replace("/");
      }
    };

    if (authData) {
      logout({
        variables: {
          refreshToken: authData.token.refreshToken ?? authData.token.accessToken,
        },
        context: {
          headers: { Authorization: `Bearer ${authData.token.accessToken}` },
        },
      }).finally(() => {
        void finalizeLogout();
      });
      return;
    }

    void finalizeLogout();
  };
}
